// @ts-strict-ignore
import { GetBadgeGroupsShowResponse } from 'mytours-read-api-typescript'
import { getApi, getConfiguration } from 'mytours-read-common'
import stqryBunnyReadApi from '../api/stqryBunnyReadApi'
import db from '../db'
import { DexieBadgeGroup } from '../db/types'
import { getAccountId, shouldUsePublishedContent } from '../settings/functions'

export const loadBadgeGroup = async (
	id: number,
	version: number,
	accountId: number | undefined,
	language: string,
	forseLoadFromNetwork?: boolean,
	onError?: (e: Error) => void,
): Promise<DexieBadgeGroup> => {
	const platform = getConfiguration().getPlatform()
	const loadedBadgeGroup = await db.badgeGroups.get({ id, version })
	if (loadedBadgeGroup && !forseLoadFromNetwork) {
		return loadedBadgeGroup
	}
	try {
		let badgeGroup: GetBadgeGroupsShowResponse
		if (shouldUsePublishedContent()) {
			badgeGroup = await stqryBunnyReadApi.fetchBadgeGroup(accountId || getAccountId(), id, version, language)
		} else {
			badgeGroup = await getApi().badgeGroupsShow(platform, id, version, language)
		}
		const toDelete = []
		await db.badges
			.where('group_id')
			.equals(id)
			.eachPrimaryKey(key => toDelete.push(key))
		await db.badges.bulkDelete(toDelete)
		badgeGroup.badges.map(async badge => {
			const triggersToDelete = []
			await db.triggers
				.where('badge_id')
				.equals(badge.id)
				.eachPrimaryKey(key => triggersToDelete.push(key))
			await db.triggers.bulkDelete(triggersToDelete)
			badge.triggers.map(async trigger => {
				await db.triggers.put({ badge_id: badge.id, ...trigger }, trigger.id)
			})
			delete badge.triggers
			await db.badges.put({ group_id: id, ...badge }, badge.id)
		})
		delete badgeGroup.badges
		await db.badgeGroups.put(badgeGroup, id)
		return badgeGroup
	} catch (e) {
		onError?.(e)
		console.error('Error while loading badge group: ', e)
	}
}

export const addToRecentlyEarnedBadges = async (badgeId: number): Promise<void> => {
	await db.recentlyEarnedBadges.put({ badge_id: badgeId, timestamp: Math.floor(Date.now() / 1000) })
}
